import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Box from '@mui/material/Box';
import { ErrorWithIcon } from '@ui/components/common/TextField/ErrorWithIcon';
import { Typography } from '@mui/material';
import { REGISTRATION_FIELD_FILL_BG } from '../registrationFormFieldStyles';
import { Controller } from 'react-hook-form';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InfoIconTooltip from '@ui/components/common/Tooltips/InfoIconTooltip';
const ECheckboxGroup = ({ name, control, label, options, rules, error, bgColor = REGISTRATION_FIELD_FILL_BG, tooltipText, disabled = false, ...rest }) => {
    const styledLabel = useMemo(() => !label ? undefined : (_jsxs(Box, { display: 'inline-flex', alignItems: 'center', gap: '4px', sx: { pointerEvents: 'auto' }, children: [_jsx(Typography, { variant: 'body2', color: disabled ? 'text.disabled' : 'text.primary', children: label }), tooltipText && (_jsx(Box, { sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                }, children: _jsx(InfoIconTooltip, { title: tooltipText, size: 'small', variant: 'dark' }) }))] })), [label, tooltipText]);
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (_jsxs(Box, { width: '100%', children: [_jsxs(Box, { sx: {
                        background: bgColor,
                        borderRadius: '12px',
                        padding: '12px',
                        width: '100%'
                    }, children: [styledLabel, _jsx(FormGroup, { ...rest, sx: { ml: 1, mt: 1 }, children: options.map((opt) => (_jsx(FormControlLabel, { disabled: disabled, control: _jsx(Checkbox, { disabled: disabled, checked: Array.isArray(field.value) ? field.value.includes(opt.value) : false, onChange: (e) => {
                                        if (disabled)
                                            return;
                                        const checked = e.target.checked;
                                        let newValue = Array.isArray(field.value) ? [...field.value] : [];
                                        if (checked) {
                                            newValue.push(opt.value);
                                        }
                                        else {
                                            newValue = newValue.filter((v) => v !== opt.value);
                                        }
                                        field.onChange(newValue);
                                    } }), label: opt.label, sx: {
                                    marginBottom: '16px',
                                    marginLeft: 0,
                                    '.MuiTypography-root': {
                                        fontSize: '14px',
                                        ml: 1,
                                        fontWeight: 400
                                    }
                                } }, opt.value))) })] }), _jsx(ErrorWithIcon, { error: error, mt: 0.5, ml: 0.5 })] })) }));
};
export default ECheckboxGroup;
